//model.js
import React, { useEffect, useRef } from 'react';
import './SuccessModal.css';
import { Button } from 'react-bootstrap';

const SucessModal = ({ show, onClose, message,headerText}) => {
    const okButtonRef = useRef(null); // Create a ref for the OK button
    
    
    let headerClass = 'default-header';
    let defaultHeaderText = 'ℹ️ Information';

    if (headerText.includes('Success')) {
        headerClass = 'success-header';
    } else if (headerText.includes('Warning')) {
        headerClass = 'warning-header';
    } else if (headerText.includes('Failed')) {
        headerClass = 'failed-header';
    }

    useEffect(() => {
        if (show && okButtonRef.current) {
            okButtonRef.current.focus();
        }
        
    }, [show]);

    if (!show) {
        return null;
    }

    return (
        <div className="warning-modal-overlay">
            <div className="warning-modal-content warning-modal-content">
            <div className={`warning-modal-header ${headerClass}`}>
            <h2>{headerText ||defaultHeaderText}</h2>
        </div>

                <div className="warning-modal-body">
                    <p>{message}</p>
                </div>
                <div className="cancel-button">

                    <Button onClick={onClose}
                     ref={okButtonRef} // Attach the ref to the OK button
                      variant="primary">
                        OK
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SucessModal;